export const WHITE_COLOR = {
  "60": "rgba(255, 255, 255, 0.6)",
};
